module.exports = __webpack_public_path__ + "static/media/background-question.47fc4aba.jpeg";